import React, {Component} from 'react';
 
import {Accordion} from 'react-bootstrap';

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic2.jpg";
 

import blogGridPic1 from "../../images/blog/grid/enfq/pic1.jpg";
import blogGridPic2 from "../../images/blog/grid/enfq/pic2.jpg";
import blogGridPic3 from "../../images/blog/grid/enfq/pic3.jpg";
import blogGridPic4 from "../../images/blog/grid/enfq/pic4.jpg";
import blogGridPic5 from "../../images/blog/grid/enfq/pic5.jpg";
import blogGridPic6 from "../../images/blog/grid/enfq/pic6.jpg";
// Blog Content
const content = [
	{ 
		name: "Gastritis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=5lc2UP8waIc",		
		definition: "https://medlineplus.gov/spanish/ency/article/001150.htm",
		image:blogGridPic1
	},
	{ 
		name: "Síndrome de Intestino Irritable",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=YBAIPdKPNyA",		
		definition: "https://medlineplus.gov/spanish/irritablebowelsyndrome.html",
		image:blogGridPic2
	},
	{ 
		name: "Colitis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=w0eitJKI5ak",		
		definition: "https://medlineplus.gov/spanish/ency/article/001125.htm",
		image:blogGridPic3
	},
	{ 
		name: "Diverticulitis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=BYfxmnBfjLE",		
		definition: "https://medlineplus.gov/spanish/diverticulosisanddiverticulitis.html",
		image:blogGridPic4
	},
	{ 
		name: "Gastroenteritis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=Ulezc-1tTyI",		
		definition: "https://medlineplus.gov/spanish/gastroenteritis.html",
		image:blogGridPic5
	},
	{ 
		name: "Ulceras Gástricas",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=--cu0abockM",		
		definition: "https://medlineplus.gov/spanish/pepticulcer.html",
		image:blogGridPic6
	},
	
]

class ServiceE extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Enfermedades Digestivas Médicas</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</a></li>
											<li className="breadcrumb-item active" aria-current="page">Enfermedades Digestivas Médicas</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-12 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded mx-auto d-block" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15">Enfermedad por reflujo gastroesofágico</h2>
											<p className="mb-0">
											Es un trastorno que se desarrolla cuando el contenido gástrico o duodenal pasa hacia la luz del esófago a través de un esfínter esofágico inferior incompetente. Es una de las causas más comunes de consulta médica en atención primaria, ya que puede ocasionar molestias importantes.  

La fisiopatología de la ERGE es compleja y obedece a un modelo multifactorial en el que parecen estar implicados mecanismos digestivos, respiratorios, neuroendocrinos y psicológicos.

A lo largo del día, todas las personas presentan relajaciones del esfínter esofágico inferior de forma fisiológica, sin producir por ello síntomas ni lesiones. El volumen y el contenido ácido del material refluido, así como el tiempo en que permanece en contacto con la mucosa del esófago, son factores que influyen en la aparición de los síntomas y en el daño de la mucosa (esofagitis). Las situaciones de estrés favorecen la percepción de los síntomas, incluso en casos en los que la medición del reflujo se considera no patológica
											</p>
										</div>
										 
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Factores de riesgo para la ERGE</h4>
											<p className="mb-0">Factores genéticos, obesidad central, ganancia reciente de peso, consumo de tabaco, presencia de hernia de hiato, dormir en posición de decúbito lateral derecho, algunos alimentos, ciertos hábitos. Tanto la práctica de ejercicio físico moderado como elevar la cabecera de la cama unos centímetros pueden ayudar a evitar los síntomas.</p>
										</div>
										<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>Principales síntomas</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">La gravedad de los síntomas de la ERGE no es un buen predictor de la intensidad del reflujo ni de la existencia de lesiones. Entre los síntomas más importantes se encuentran los siguientes: Sensación de ardor que asciende desde el estómago hacia el cuello y Retorno sin esfuerzo del contenido gástrico al esófago, o hasta la boca.</p>
												</Accordion.Body>
											</Accordion.Item>
											 
										</Accordion>
									</div>
								</div>
 
							</div>
						</div>
						<div className="page-banner-entry text-center">
							<h2>Otras Enfermedades Digestivas Médicas</h2>
						</div>
					</section>
					<div className="container">

				<div className="row">
					{content.map((item) =>(
						<div className="col-xl-4 col-md-6">
							<div className="blog-card mb-30">
								<div className="post-media">
									<img src={item.image} alt=""/>
								</div>
								<div className="post-info">
								<h5 className="post-title" onClick={()=> window.open(item.definition, "_blank")}>{item.name}{item.subName}</h5>	
									<ul className="post-meta">
										<li className="author" onClick={()=> window.open(item.youtube, "_blank")}><i className="la la-youtube"></i>Video Informativo</li>
										<li className="date"  onClick={()=> window.open(item.definition, "_blank")}><i className="fa fa-info-circle"></i>Mas Información</li>
									</ul>
										
								</div>
							</div>							
						</div>
					))}
				</div>

				</div>
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ServiceE;
